import { PaddingContainer, WidthContainer } from '@components';
import { HowToMeasurePeopleItems } from '@store/LocationAssetsTrackingData';
import classNames from 'classnames';
import React from 'react';

import * as styles from './HowToMeasurePeople.module.scss';

export const HowToMeasurePeople: React.FC = () => {
	return (
		<PaddingContainer className="white-bg">
			<WidthContainer>
				<h3 className="font-size-small-title mb-5">How to measure people: </h3>
				<div className={classNames(styles.list, 'd-flex flex-wrap')}>
					{HowToMeasurePeopleItems.map((item) => (
						<div className={classNames(styles.item, 'd-flex font-size-sm')}>
							<div className={classNames(styles.image, 'flex-shrink-0')}>
								<img src={item.icon} />
							</div>
							<div>
								<p className="font-600">{item.title}</p>
								{item.content}
							</div>
						</div>
					))}
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
